<template>
<!-- ========== Topbar Start ========== -->
<div class="navbar-custom">
    <div class="topbar container-fluid">
        <div class="d-flex align-items-center gap-lg-2 gap-1">

            <!-- Topbar Brand Logo -->
            <div class="logo-topbar">
                <!-- Logo light -->
                <router-link to="/kosiwon/list" class="logo-light">
                    <span class="logo-lg">
                        <img src="assets/images/logo.png" alt="logo">
                    </span>
                    <span class="logo-sm">
                        <img src="assets/images/logo-sm.png" alt="small logo">
                    </span>
                </router-link>

                <!-- Logo Dark -->
                <router-link to="/kosiwon/list" class="logo-dark">
                    <span class="logo-lg">
                        <img src="assets/images/logo-dark.png" alt="dark logo">
                    </span>
                    <span class="logo-sm">
                        <img src="assets/images/logo-dark-sm.png" alt="small logo">
                    </span>
                </router-link>
            </div>

            <!-- Sidebar Menu Toggle Button -->
            <button class="button-toggle-menu">
                <i class="mdi mdi-menu"></i>
            </button>

            <!-- Horizontal Menu Toggle Button -->
            <button class="navbar-toggle" data-bs-toggle="collapse" data-bs-target="#topnav-menu-content">
                <div class="lines">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </button>
        </div>

        <ul class="topbar-menu d-flex align-items-center gap-3">
            <li class="dropdown notification-list">
                <a class="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                    <i class="ri-notification-3-line font-22"></i>
                    <span class="noti-icon-badge" v-if="unreadNotificationsCnt > 0"></span>
                </a>
                <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated dropdown-lg py-0">
                    <div class="p-2 border-top-0 border-start-0 border-end-0 border-dashed border">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="m-0 font-16 fw-semibold">알림 내역</h6>
                            </div>
                            <div class="col-auto">
                                <a class="text-dark text-decoration-underline" @click="allReadNotification()">
                                    <small>모두 읽기</small>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="px-2" style="max-height: 300px;" data-simplebar>
                        <div v-for="(group, date) in groupedNotifications" :key="date">
                            <h5 class="text-muted font-13 fw-normal mt-2"> {{ date }}</h5>
                            <a class="dropdown-item p-0 notify-item card shadow-none mb-2" :class="readClass(noti)" v-for="(noti, idx) in group" :key="`noti_${date}_${idx}`" @click="readNotification(noti)">
                                <div class="card-body">
                                    <span class="float-end noti-close-btn text-muted"></span>
                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0">
                                            <div class="notify-icon" :class="bgClass(noti)">
                                                <i class="mdi" :class="senderIconClass(noti)"></i>
                                            </div>
                                        </div>
                                        <div class="flex-grow-1 text-truncate ms-2">
                                            <h5 class="noti-item-title fw-semibold font-14">{{ noti.title }}
                                                <small class="fw-normal text-muted ms-1">{{ GET_TIME_AGO(noti.created) }}</small>
                                            </h5>
                                            <small class="noti-item-subtitle text-muted">{{ noti.message }}</small>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <router-link to="/notification" class="dropdown-item text-center text-primary notify-item border-top py-2">
                        모두 보기
                    </router-link>
                </div>
            </li>

            <li class="d-sm-inline-block">
                <div class="nav-link" id="light-dark-mode" data-bs-toggle="tooltip" data-bs-placement="left" title="Light/ Dark Mode">
                    <i class="ri-moon-line font-22"></i>
                </div>
            </li>

            <li class="dropdown">
                <a class="nav-link dropdown-toggle arrow-none nav-user px-2" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                    <span class="account-user-avatar">
                        <img :src="$store.state.userInfo.image_url" alt="user-image" width="32" height="32" class="rounded-circle object-fit-cover">
                    </span>
                    <span class="d-lg-flex flex-column gap-1 d-none">
                        <h5 class="my-0">{{ $store.state.userInfo.name }}</h5>
                    </span>
                </a>
                <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown">
                    <router-link to="/mypage" class="dropdown-item">
                        <i class="mdi mdi-account-circle-outline me-1"></i>
                        <span>마이 페이지</span>
                    </router-link>
                    <router-link to="/notification" class="dropdown-item">
                        <i class="mdi mdi-bell-ring-outline me-1"></i>
                        <span>알림 내역</span>
                    </router-link>
                    <a class="dropdown-item" @click="logout()">
                        <i class="mdi mdi-logout me-1"></i>
                        <span>로그아웃</span>
                    </a>
                </div>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
import {
    GET_TIME_AGO
} from "@/config/date.js";

export default {
    data() {
        return {
            GET_TIME_AGO: GET_TIME_AGO
        }
    },
    computed: {
        groupedNotifications() {
            return this.$store.getters.groupedNotifications;
        },
        unreadNotificationsCnt() {
            return this.$store.getters.unreadNotificationsCnt;
        }
    },
    watch: {
        $route() {
            // path가 변경될 때 마다, 알림 가져오는 구문
            this.$store.dispatch("fetchNotification");
        },
    },
    methods: {
        async logout() {
            if (confirm("로그아웃하시겠습니까?")) {
                try {
                    await this.$store.dispatch("logout");
                } catch (error) {
                    console.log(error);
                }
            }
        },
        readClass(noti) {
            return noti.is_read ? "unread-noti" : "read-noti";
        },
        senderIconClass(noti) {
            return noti.sender === "USER" ? "mdi-email-send-outline" : "mdi-email-receive-outline";
        },
        bgClass(noti) {
            return noti.is_read ? "bg-secondary" : noti.bg_color;
        },
        readNotification(noti) {
            if (!noti.is_read) {
                this.$store.dispatch("readNotification", noti.pk);
            }

            this.$router.push({
                path: "/notification"
            });
        },
        allReadNotification() {
            if (this.unreadNotificationsCnt > 0) {
                this.$store.dispatch("allReadNotification");
            }
        },
    }
};
</script>
